import type { ReactNode } from 'react';

import { useOptionalPageBridgeProps } from './usePageBridgeProps';

// Resolves the on-page title for fallback states (loading/error) where
// `leafLabel` may be empty because the resource name hasn't loaded yet.
// Falls back to the page's descriptor title (e.g. "Fact table") so the
// header keeps a meaningful label.
export const usePageTitle = (): ReactNode => {
  const bridgeProps = useOptionalPageBridgeProps();
  return bridgeProps?.leafLabel || bridgeProps?.descriptor.title;
};
